import { Navigate } from "react-router-dom";

/** 旧链接 /ebooks 重定向到读书会-电子书 Tab */
export default function EbookCenter() {
  return <Navigate to="/book-club?tab=ebooks" replace />;
}
